import { Button } from '@mui/material';
import React from 'react';
import * as XLSX from 'xlsx-js-style';
import PropTypes from 'prop-types';
import Iconify from 'src/components/iconify';
import { headers } from './view/data';

function DownloadForRSPersonal({ rsData }) {
  const exportToExcel = () => {
    // First Sheet (personal headers)
    const ws1 = XLSX.utils.json_to_sheet(rsData?.transformedDataFirst, {
      header: [
        'GZ Number',
        'გზ.ნომერი',
        'პირადი ნომერი',
        'სახელი',
        'გვარი',
        'ტელეფონი',
        'მისამართი',
        'ქვეყანის კოდი',
        'წონა',
        'გზ. ტიპი',
        'დაბ.ტიპი',
        'რეგ.თარიღი',
        'საწყობში შემოტანის თარიღი',
        'დოკუმენტის ნომერი',
        'ტრანსპორტირების ხარჯები 1',
        'ტრანსპორტირების ხარჯები 1-ის ვალუტა',
        'ტრანსპორტირების ხარჯები  2',
        'ტრანსპორტირების ხარჯები 2-ის ვალუტა',
        'ტრანსპორტირების სხვა ხარჯები',
        'ტრანსპორტირების სხვა ხარჯების ვალუტა',
        'მაღაზიის სახელი',
        'შენიშვნა',
        'რეისის ნომერი',
        'დაბრუნებული',
      ],
    });

  
    const targetHeader = 'დაბ.ტიპი';
    const targetIdx = headers.indexOf(targetHeader);
    if (targetIdx !== -1 && Array.isArray(rsData?.transformedDataFirst)) {
      const startRow = 2;
      rsData.transformedDataFirst.forEach((row, rowIndex) => {
        const value = row[targetHeader];
        if (value === 1 || value === '1') {
          const cellAddress = XLSX.utils.encode_cell({ r: startRow - 1 + rowIndex, c: targetIdx });
          if (!ws1[cellAddress]) ws1[cellAddress] = { t: 'n', v: value };
          ws1[cellAddress].s = {
            fill: { patternType: 'solid', fgColor: { rgb: 'FFFFCCCC' } },
            font: { color: { rgb: 'FF0000' } },
          };
        }
      });
    }

    // Highlight 'GZ Number' in blue when same name+lastname have different GZ Number
    if (Array.isArray(rsData?.transformedDataFirst)) {
      const nameKeyToGzSet = new Map();
      const nameHeader = 'სახელი';
      const lastNameHeader = 'გვარი';
      const gzHeader = 'GZ Number';

      // Build mapping from name+lastname to set of GZ Numbers
      rsData.transformedDataFirst.forEach((row) => {
        const name = row[nameHeader] || '';
        const lastName = row[lastNameHeader] || '';
        const gz = row[gzHeader] || '';
        if (!name || !lastName) return;
        const key = `${name}|${lastName}`;
        if (!nameKeyToGzSet.has(key)) nameKeyToGzSet.set(key, new Set());
        nameKeyToGzSet.get(key).add(gz);
      });

      // Determine GZ column index
      const gzColIdx = headers.indexOf(gzHeader);
      const startRow = 2; // after header

      if (gzColIdx !== -1) {
        rsData.transformedDataFirst.forEach((row, rowIndex) => {
          const name = row[nameHeader] || '';
          const lastName = row[lastNameHeader] || '';
          if (!name || !lastName) return;
          const key = `${name}|${lastName}`;
          const gzSet = nameKeyToGzSet.get(key);
          if (gzSet && gzSet.size > 1) {
            const cellAddress = XLSX.utils.encode_cell({ r: startRow - 1 + rowIndex, c: gzColIdx });
            if (!ws1[cellAddress]) ws1[cellAddress] = { t: 's', v: row[gzHeader] || '' };
            ws1[cellAddress].s = {
              fill: { patternType: 'solid', fgColor: { rgb: 'FFCCE5FF' } }, // light blue
            };
          }
        });
      }
    }

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws1, 'Main');
    // Second Sheet (personal headers)
    const ws2 = XLSX.utils.json_to_sheet(rsData?.transformedDataSecond, {
      header: [
        'გზ.ნომერი',
        'საქონლის კოდი',
        'დასახელება',
        'რაოდენობა',
        'ფასი (ვალუტაში)',
        'ვალუტა',
        'შეღავათი',
      ],
    });
    XLSX.utils.book_append_sheet(wb, ws2, 'Items');
    XLSX.writeFile(wb, 'rsData_personal.xlsx');
  };

  return (
    <Button
      onClick={exportToExcel}
      variant="contained"
      disabled={!rsData?.transformedDataFirst?.length}
      startIcon={<Iconify icon="material-symbols:download" />}
      style={{ fontSize: '0.7rem' }}
    >
      DOWNLOAD (PERSONAL)
    </Button>
  );
}

DownloadForRSPersonal.propTypes = {
  rsData: PropTypes.object,
};

export default DownloadForRSPersonal;
